import { error } from './error';
import { info } from './info';
import { success } from './success';

export const toast = {
  success,
  error,
  info,
};
